import { useEffect } from "react";
import { formatWithLocale } from "../../../../lib/date_fns_locale";

function AmPmSelector({
  className,
  disabled,
  onChange,
  value,
}: {
  className?: string;
  disabled?: boolean;
  onChange: (ampm: string) => void;
  value?: string;
}) {
  // Default to "am" if no value was passed in.
  useEffect(() => {
    if (!value) onChange("am");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <select
      className={`cursor-pointer focus:z-50 ${className ? className : ""} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      value={value}
    >
      <option value="am">
        {formatWithLocale(new Date(2020, 1, 1, 1), "aaa")}
      </option>
      <option value="pm">
        {formatWithLocale(new Date(2020, 1, 1, 23), "aaa")}
      </option>
    </select>
  );
}

export default AmPmSelector;
